import React, { Component } from 'react'
import { Accordion, Icon } from 'semantic-ui-react'
import './styles.scss'
import { parseHostname } from '@ta-interaktiv/parse-hostname'

export default class PrivacyPolicy extends Component {
  state = { activeIndex: 0 }

  handleClick = (e, titleProps) => {
    const { index } = titleProps
    const { activeIndex } = this.state
    const newIndex = activeIndex === index ? -1 : index

    this.setState({ activeIndex: newIndex })
  }

  render() {
    const { activeIndex } = this.state

    return (
      <div className='privacy-policy'>
        <Accordion fluid styled>
          <Accordion.Title
            active={activeIndex === 0}
            index={0}
            onClick={this.handleClick}
          >
            <Icon name='dropdown' />
            Collecte de données
          </Accordion.Title>
          <Accordion.Content active={activeIndex === 0}>
            <p>Nous recueillons et conservons les données suivantes:</p>
            <ul>
              <li>Les 100 meilleures chansons de votre compte Spotify</li>
              <li>
                Les moyennes des attributs musicaux listés dans l’article pour
                vos 100 meilleures chansons
              </li>
              <li>Votre âge stocké sur Spotify</li>
            </ul>
            <p>
              Nous utilisons les données ainsi enregistrées exclusivement pour
              l'analyse et la visualisation dans le cadre de cet article, ainsi
              que pour un éventuel article de suivi.
            </p>
            <p>
              Toutes les données ainsi utilisées sont anonymes et ne sont pas
              affectées à des données personnelles (par exemple, en combinant
              les données avec des comptes, cookies, adresses IP ou autres).
            </p>
          </Accordion.Content>

          <Accordion.Title
            active={activeIndex === 1}
            index={1}
            onClick={this.handleClick}
          >
            <Icon name='dropdown' />
            Google Analytics
          </Accordion.Title>
          <Accordion.Content active={activeIndex === 1}>
            <p>
              Le logiciel Google Analytics est utilisé pour les statistiques des
              utilisateurs. Les données qui y sont recueillies ne peuvent être
              reliées à des données recueillies ailleurs (y compris les données
              énumérées ci-dessus). L'utilisation de Google Analytics dans
              l'analyse du goût musical de Tamedia correspond à celle des
              portails d'information du groupe Tamedia. Vous trouverez de plus
              amples informations dans la{' '}
              <a
                href={
                  'https://abo.' +
                  parseHostname().publicationName +
                  '.ch/tamstorefront/terms/register'
                }
              >
                politique de confidentialité
              </a>{' '}
              de Tamedia.
            </p>
          </Accordion.Content>
        </Accordion>
      </div>
    )
  }
}
